import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, Typography, Tab, Tabs, CircularProgress } from '@mui/material';
import "../styles/startupListing.css"
import DynamicCard from './CardComponent';
import { callApi } from '../../common/api';
import CustomizedSnackbars from "../alert/alert";
import StartUpDetails from '../../components/StartUpDetails';
import { useLocation } from "react-router-dom";

const StartupListing = () => {
  const sampleArr = [1, 2, 3, 4, 5, 6]
  const [data, setData] = useState({});
  const [isData, setIsData] = useState(false)
  const [loading, setLoading] = useState(true); // Added loading state
  const [Id, setId] = React.useState(null)
  const [mobileWidth, setMobileWidth] = React.useState(false)
  const [snackBarMsg, setSnackBarMsg] = useState({
    message: "",
    severity: "success",
    open: false,
  });
  const [value, setValue] = React.useState(0)
  const [num, setNum] = useState(1)

  const allStartups = async () => {
    try {
      setLoading(true); // Start loader
      const response = await callApi("get", `startup/allStartup`);
      if (response.data.response.status) {
        // setSnackBarMsg({
        //   message: response?.data?.response?.message,
        //   severity: "success",
        //   open: true
        // })
        return response.data.response.data
      }
    } catch (error) {
      if (error.response) {
        setSnackBarMsg({
          message: error.response.data.message,
          severity: "error",
          open: true,
        });
      }
    } finally {
      setLoading(false); // Stop loader
    }
  }

  const location = useLocation();
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 768) {
        setMobileWidth(false);
      } else {
        setMobileWidth(true);
      }
    }

    // Initial call to handleResize to set initial value
    window.addEventListener('resize', handleResize)
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [mobileWidth])
  const handleTabValue = (event, newValue) => {
    setValue(newValue)
  }
  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id")
    if (id != null) {
      const button = document.getElementById(`${id}`);
      button.click()
      return;
    }
  }, [])
  useEffect(() => {
    allStartups().then((key) => {
      setData(key)
      setIsData(true)
    });
  }, [])

  const handleClick = async (dealId, startUpId) => {
    localStorage.setItem("startUpId", JSON.stringify(startUpId));
    localStorage.setItem("dealId", JSON.stringify(dealId));
    let obj = {
      startupDealId: dealId,
      source: 0
    }
    try {
      const response = await callApi("post", "lead/createLead", obj)
      if (response.data.response.status) {
        window.location.href = "/startUpDetails"
      }
    } catch (err) {
      console.log(err)
    }
  }
  
  const changeButton = (n) => {
    setNum(n)
  }

  return (
    <>
      <Box className="mainContainer container">
        {loading ? (
          <Box className="loaderContainer" display="flex" justifyContent="center" alignItems="center" height="100vh">
            <CircularProgress />
          </Box>
        ) : (
          <>
            {mobileWidth == false ?
              <Box className="startupType" tyle={{ display: 'flex', flexDirection: 'row', gap: '12px', justifyContent: 'center', width: 'auto', maxWidth: '70%' }} >
                <Button name="button1" variant='outlined' style={{ color: '#7a7a7a', border: 'none', display: 'flex', justifyContent: 'flex-start', fontSize: '16px', maxWidth: '100%', width: '100%' }}><a id="1" onClick={() => { changeButton(1) }} className='anchor' style={{ color: num === 1 ? "white" : "#7a7a7a" }} href="#startUp">
                  Start Up Equity</a>
                </Button>
                {/* <Button disabled={false} variant='outlined' name="button2" style={{ color: '#7a7a7a', border: 'none', display: 'flex', justifyContent: 'flex-start', fontSize: '16px', width: '100%' }} ><a id="2" onClick={() => { changeButton(2) }} className='anchor' style={{ color: num === 2 ? "white" : "#7a7a7a" }} href="#debt">
                  Debt </a>
                </Button> */}
                <Button disabled={false} variant='outlined' name="button3" style={{ color: '#7a7a7a', border: 'none', display: 'flex', justifyContent: 'flex-start', fontSize: '16px', width: '100%' }}><a id="3" onClick={() => { changeButton(3) }} className='anchor' style={{ color: num === 3 ? "white" : "#7a7a7a" }} href="#Merge">
                  Mergers and Acquisition</a>
                </Button>
              </Box> :
              <Tabs 
              className='tabs'
              sx={{
                marginBottom: '16px', color: 'white', '& .MuiTabs-indicator': {
                  backgroundColor: 'white',
                  fontSize: '22px',
                  color: 'white'
                },
                '&.Mui-selected': {
                  backgroundColor: 'white',
                  color: 'white'
                }
              }} value={value} onChange={handleTabValue}>
                <Tab sx={{ color: value == 0 ? 'white' : 'white' }} label='Start Up Equity' />
                <Tab sx={{ color: value == 1 ? 'white' : 'white' }} label='Debt' />
                <Tab sx={{ color: value == 2 ? 'white' : 'white' }} label='Mergers and Acquisition' />
              </Tabs>
            }
            {mobileWidth == false ?
              <Box className="dynamicComponent" >
                <div className='startUP' id='startUp'>
                  <Typography variant="h4" className='text' sx={{ fontSize: '22px' }}>Start Up Equity</Typography>
                </div>
                <Grid className="outerBox removePadding gap-24px">

                  {data && data["Equity"]?.map((eq, index) => {
                    return <DynamicCard key={index} onButtonClick={handleClick} dealid={eq.dealid} startUpId={eq.id} resource={eq.resource?.basicDetails} imageData={eq?.companylogo} />
                  })}
                </Grid>
                <div className='textDiv' id='debt'>
                  <Typography variant="h4" className='text' sx={{ fontSize: '22px' }}>Debt</Typography>
                </div>
                <Grid className="outerBox removePadding gap-24px">

                  {data && data["Debt"]?.map((debt, index) => {
                    return <DynamicCard key={index} onButtonClick={handleClick} dealid={debt.dealid} startUpId={debt.id} resource={debt.resource?.basicDetails} imageData={debt?.companylogo} />
                  })}
                </Grid>
                <div className='textDiv' id='Merge'>
                  <Typography variant="h4" className='text' sx={{ fontSize: '22px' }}>Mergers and Acquisition</Typography>
                </div>
                <Grid className="outerBox removePadding gap-24px">

                  {data && data["Mergers and Acquisition"]?.map((mergers, index) => {
                    return <DynamicCard key={index} onButtonClick={handleClick} dealid={mergers.dealid} startUpId={mergers.id} resource={mergers.resource?.basicDetails} imageData={mergers?.companylogo} />
                  })}
                </Grid>
              </Box> :
              <Box className="dynamicComponent">
                {value == 0 ?
                  <div>
                    <div className='startUP marginBottom-16px' id='startUp'>
                      <Typography variant="h4" className='text' sx={{ fontSize: '22px' }}>Start Up Equity</Typography>
                    </div>
                    <Grid className="outerBox gap-16px">

                      {data && data["Equity"]?.map((eq, index) => {
                        return <DynamicCard key={index} onButtonClick={handleClick} dealid={eq.dealid} startUpId={eq.id} resource={eq.resource?.basicDetails} imageData={eq?.companylogo} />
                      })}
                    </Grid>
                  </div> : ""}
                {value == 1 ?
                  <div>
                    <div className='textDiv marginBottom-16px' id='debt'>
                      <Typography variant="h4" className='text' sx={{ fontSize: '22px' }}>Debt</Typography>
                    </div>
                    <Grid className="outerBox gap-16px">

                      {data && data["Debt"]?.map((debt, index) => {
                        return <DynamicCard key={index} onButtonClick={handleClick} dealid={debt.dealid} startUpId={debt.id} resource={debt.resource?.basicDetails} imageData={debt?.companylogo} />
                      })}
                    </Grid>
                  </div> : ""}
                {value == 2 && data["Mergers and Acquisition"] ?
                  <div>
                    <div className='textDiv marginBottom-16px' id='Merge'>
                      <Typography variant="h4" className='text' sx={{ fontSize: '22px' }}>Mergers and Acquisition</Typography>
                    </div>
                    <Grid className="outerBox gap-16px">

                      {data && data["Mergers and Acquisition"]?.map((mergers, index) => {
                        return <DynamicCard key={index} onButtonClick={handleClick} dealid={mergers.dealid} startUpId={mergers.id} resource={mergers.resource?.basicDetails} imageData={mergers?.companylogo} />
                      })}
                    </Grid>
                  </div> : "No Startup Deals Available"}
              </Box>
            }
          </>
        )}
      </Box>
      <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
    </>
  )
}

export default StartupListing
